import icons from "../../../../content/images/desktop-icons.png";
import * as React from 'react';
export default {
  icons,
  React
};